import { filterPurchaseOrderQueue } from "@/lib/manufacturing/purchaseOrderQueue";
import {
  isPlantMaterialRequest,
  plantRequestInboxBlurb,
  plantRequestPhase,
} from "@/lib/manufacturing/plantMaterialRequest";
import type { MfgPurchaseOrder } from "@/lib/manufacturing/purchaseOrderTypes";

export function PlantMaterialRequestInbox(props: {
  orders: MfgPurchaseOrder[];
  onOpen: (poId: string) => void;
}) {
  const rows = filterPurchaseOrderQueue(props.orders, "requests").filter((o) =>
    isPlantMaterialRequest(o),
  );
  if (rows.length === 0) return null;
  return (
    <section className="rounded-lg border border-amber-200 bg-amber-50/60 p-3 dark:border-amber-800 dark:bg-amber-950/20">
      <h3 className="text-sm font-semibold text-amber-950 dark:text-amber-100">
        Notes and requests
      </h3>
      <p className="mt-0.5 text-[11px] text-amber-900/80 dark:text-amber-200/80">
        Floor asks — start a PO, split vendors if needed. The plant is not picking vendors.
      </p>
      <ul className="mt-2 space-y-1.5">
        {rows.map((order) => {
          const phase = plantRequestPhase(order, props.orders);
          return (
            <li key={order.id}>
              <button
                type="button"
                onClick={() => props.onOpen(order.id)}
                className="w-full rounded-md border border-amber-200 bg-white px-3 py-2 text-left text-xs hover:border-amber-400 dark:border-amber-900 dark:bg-zinc-900"
              >
                <span className="font-semibold">{order.po_number}</span>
                <span className="ml-2 text-gray-500">
                  {phase === "submitted"
                    ? "not acknowledged"
                    : phase === "acknowledged"
                      ? "acknowledged"
                      : phase ?? "request"}
                </span>
                <p className="mt-0.5 text-gray-800 dark:text-zinc-100">
                  {plantRequestInboxBlurb(order)}
                </p>
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
